import React, { useState } from 'react';
import { FaHome, FaBriefcase } from 'react-icons/fa';
import NewRentalContract from '../NewRentalContract/NewRentalContract';
import NewAdminRentalContract from '../../AdminRentalsManagement/NewAdminRentalContract/NewAdminRentalContract';
import style from './NewContractChooser.module.css';

/**
 * Modal selector que pregunta qué tipo de contrato cargar.
 * Una vez elegido, abre el form correspondiente (NewRentalContract o NewAdminRentalContract).
 *
 * Props:
 * - onClose: () => void
 * - onSuccess?: () => void  // se llama cuando el form interno se cierra exitosamente
 */
const NewContractChooser = ({ onClose, onSuccess }) => {
  const [chosen, setChosen] = useState(null); // null | 'regular' | 'admin'

  const handleClose = () => {
    setChosen(null);
    onClose?.();
  };

  if (chosen === 'regular') {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(15,23,42,0.55)',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          zIndex: 1000,
          padding: 16,
          overflowY: 'auto',
        }}
        onClick={handleClose}
      >
        <div
          style={{
            background: '#fff',
            borderRadius: 12,
            maxWidth: 960,
            width: '100%',
            maxHeight: '95vh',
            overflowY: 'auto',
            margin: 'auto',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <NewRentalContract
            onClose={handleClose}
            onSuccess={() => {
              onSuccess?.();
              handleClose();
            }}
          />
        </div>
      </div>
    );
  }

  if (chosen === 'admin') {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(15,23,42,0.55)',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          zIndex: 1000,
          padding: 16,
          overflowY: 'auto',
        }}
        onClick={handleClose}
      >
        <div
          style={{
            background: '#fff',
            borderRadius: 12,
            maxWidth: 900,
            width: '100%',
            maxHeight: '95vh',
            overflowY: 'auto',
            margin: 'auto',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <NewAdminRentalContract
            onClose={() => {
              onSuccess?.();
              handleClose();
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={style.overlay} onClick={handleClose}>
      <div className={style.modal} onClick={(e) => e.stopPropagation()}>
        <h3 className={style.title}>Nuevo Contrato</h3>
        <p className={style.subtitle}>
          Elegí el tipo de contrato que querés cargar.
        </p>

        <div className={style.options}>
          <button
            type="button"
            className={style.option}
            onClick={() => setChosen('regular')}
          >
            <FaHome className={style.optionIcon} />
            <span className={style.optionTitle}>Contrato Regular</span>
            <span className={style.optionDescription}>
              La inmobiliaria comercializó la propiedad. Se vincula a una propiedad
              ya cargada en el sistema.
            </span>
          </button>

          <button
            type="button"
            className={style.option}
            onClick={() => setChosen('admin')}
          >
            <FaBriefcase className={style.optionIcon} />
            <span className={style.optionTitle}>Solo Administración</span>
            <span className={style.optionDescription}>
              Solo se administra el cobro. La propiedad se carga manualmente como
              datos embebidos del contrato.
            </span>
          </button>
        </div>

        <div className={style.cancelRow}>
          <button type="button" className={style.cancelBtn} onClick={handleClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewContractChooser;
